module.exports = __webpack_public_path__ + "img/go9.8128c6a4.png";